<template>
  <TitleWrapper
    :filter-option="true"
    title="STAFF_CAMPUS_ATTENDANCE"
    tooltip-title="STAFF_ATTEND"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper>
        <UiMultiSelect
          v-if="!isGuardianOrStudent"
          v-model.trim="filtersPayload.user_id"
          title="STAFF"
          :options="staffList"
          reduce="id"
          label="full_name"
          input-color="bg-white"
          :already-selected="selectedStaff"
          :search-through-api="true"
          :filter="FILTERS_LIST.MULTIPLE_USERS"
          @search="getStaff"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model="filtersPayload.checked_type"
          title="TYPE"
          :options="CHECKED_TYPE"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.CHECKED_TYPE"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import { getCountFromObject } from '@utils/generalUtil'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { mapActions, mapState, mapGetters } from 'vuex'
import filterMixins from '@/src/mixins/filter-mixins.js'
import { buildWhereQuery } from '@/src/utils/filters'
import { CHECKED_TYPE } from '@/src/constants/attandance/attandance-constant.js'
import UiMultiSelect from '@/src/components/UiElements/UiMultiSelect.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiMultiSelect,
    UiSingleSelect,
    TitleWrapper,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      CHECKED_TYPE,
      FILTER_KEYS,
      staffList: [],
      $where: {},
      selectedStaff: [],
      FILTERS_LIST,
      filtersPayload: {
        checked_type: '',
        user_id: [],
        displayedColumns: [],
      },
      filtersCount: 0,
    }
  },

  computed: {
    ...mapState({
      currentSectionScope: (state) => state.layout.currentSectionScope.id,
      currentCampusScope: (state) => state.layout.currentCampusScope.id,
    }),
    ...mapGetters('layout', ['userRole']),
    isGuardianOrStudent() {
      return [TENANT_ROLES.GUARDIAN, TENANT_ROLES.SECTION_STUDENT].includes(this.userRole)
    },
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getStaff()
        this.clearFilters()
      },
    },

    currentSectionScope: {
      handler() {
        this.getStaff()
        this.clearFilters()
      },
    },
  },
  mounted() {
    this.getStaff()
    this.updateDisplayedColumnList()
  },
  methods: {
    getStaff(query) {
      if (this.isGuardianOrStudent) return
      let alreadySelectedStaff = []
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query),
        },
      }
      this.getGeneralStaffWithFilters(payload).then((res) => {
        this.staffList = res?.records
        this.staffList?.forEach((record) => {
          if (this.filtersPayload && this.filtersPayload.user_id.length) {
            this.filtersPayload.user_id.forEach((id) => {
              if (record.id === id) {
                alreadySelectedStaff.push(record)
              }
            })
          }
          this.selectedStaff = alreadySelectedStaff
        })
      })
    },
    getFiltersCount() {
      this.getStaff()
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
    ...mapActions('staff', ['getGeneralStaffWithFilters']),
  },
}
</script>
